import React from 'react';
import { Task } from '../../../../../types/task';

/**
 * 任务项目信息显示组件
 * 从TaskItem.tsx第147-163行和FocusTaskItem.tsx第473-489行完全提取
 */
interface TaskProjectInfoProps {
  task: Task;
  hideProjectName?: boolean;
  onProjectClick?: (projectId: string) => void;
  t: (key: string) => string;
  className?: string; // 为未来样式扩展预留
}

export const TaskProjectInfo: React.FC<TaskProjectInfoProps> = ({
  task,
  hideProjectName,
  onProjectClick,
  t,
  className = ""
}) => {
  if (!task.projectId || hideProjectName) {
    return null;
  }

  return (
    <div
      className={`flex items-center ml-2 text-ios-footnote text-ios-gray dark:text-ios-dark-gray shrink-0 hover:text-ios-blue dark:hover:text-ios-dark-blue transition-colors duration-200 ${className}`}
      onClick={onProjectClick ? (e) => {
        e.stopPropagation(); // 阻止事件冒泡，避免触发任务点击
        onProjectClick(task.projectId!);
      } : undefined}
      style={onProjectClick ? { cursor: 'pointer' } : undefined}
    >
      <svg className="w-3 h-3 mr-0.5" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.58333 1.16667H3.5C2.85567 1.16667 2.33333 1.689 2.33333 2.33333V11.6667C2.33333 12.311 2.85567 12.8333 3.5 12.8333H10.5C11.1443 12.8333 11.6667 12.311 11.6667 11.6667V5.25L7.58333 1.16667Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7 1.16667V5.83333H11.6667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <span className="truncate">{task.project?.title || t('common:project.default')}</span>
    </div>
  );
};